import { useMemo } from 'react';
import { useCurrentOrg } from './useCurrentOrg';
import { OrgTier } from '@nexla/@types';

export function useOrgTier(): OrgTier | undefined {
  const org = useCurrentOrg();
  return useMemo(() => org?.org_tier, [org]);
}
